<template>
	<ModalBox
		v-model="legacyModalVisible"
		:size="modalSize"
		hide-close
		header-class="!hidden"
		wrapper-classes="lg:h-auto lg:max-h-none"
	>
		<div class="px-6 pt-6">
			<h4 v-if="stream" class="text-lg font-medium text-surface-text-1 mb-0 break-words line-clamp-2">
				{{ stream.enabled ? 'Disable' : 'Enable' }} {{ stream.name }}?
			</h4>
			<p v-if="stream.enabled" class="text-sm text-surface-7 mt-3 mb-0">
				<template v-if="!transcoderView">This takes the stream offline — it stops delivery to your destinations, and viewers can no longer watch it on your player or embed.</template>
				<template v-else>This stops the transcoder until you enable it again.</template>
			</p>
			<p v-else class="text-sm text-surface-7 mt-3 mb-0">
				<template v-if="!transcoderView">This turns the stream back on so it's ready to go live again for your destinations and viewers.</template>
				<template v-else>This starts the transcoder again.</template>
			</p>
		</div>
		<template #footer>
			<div class="flex justify-end gap-2 p-6">
				<FormButton type="secondary" size="md" @click="dismiss">
					{{ cancelText }}
				</FormButton>
				<FormButton
					v-if="stream.enabled"
					type="red"
					size="md"
					@click="toggleStatus"
				>
					Disable
				</FormButton>
				<FormButton
					v-if="!stream.enabled"
					type="main"
					size="md"
					@click="toggleStatus"
				>
					Enable
				</FormButton>
			</div>
		</template>
	</ModalBox>
</template>

<script>
import { showModal, hideModal } from '@/Utils/modalBus'
import ModalBox from '@/components/modals/ModalBox.vue'
import { legacyModalBridgeMixin } from '@/composables/useLegacyModalBridge'
import StreamService from '@/services/StreamService';
import TranscoderService from '@/services/TranscoderService';
import FormButton from '@/components/Atoms/FormButton.vue';
import { track, EVENTS } from '@/lib/tracking';

export default {
	name: 'ToggleStreamModal',
	mixins: [legacyModalBridgeMixin],
	computed: {
		legacyModalId() { return 'modalToggleStream' + this.stream._id },
	},
	components: {
		ModalBox, FormButton },
	emits: ['modal-toggle', 'modal-cancel', 'modal-dismiss', 'toggle-processing', 'toggle-done'],
	props: {
		stream: {
			type: Object,
			default() { return {}; }
		},
		modalId: {
			type: String,
			default: 'modal-toggle'
		},
		modalSize: {
			type: String,
			default: 'sm',
			validator(v) {
				return ['xl', 'lg', 'md', 'sm'].some(size => size === v);
			}
		},
		modalType: {
			type: String,
			default: 'primary'
		},
		body: {
			type: String,
			required: false
		},
		streamCat: {
			type: String
		},
		okText: {
			type: String,
			default: 'Disable'
		},
		cancelText: {
			type: String,
			default: 'Cancel'
		},
		transcoderView: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			processing: false,
			statusProcessing: false,
			streamStatus: this.stream.enabled,
			toggleProcessing: false
		};
	},
	methods: {
		onConfirm() {
			this.$emit('modal-toggle');
			this.dismiss();
		},
		dismiss() {
			this.$emit('modal-cancel');
			this.hideLegacyModal();
			this.$emit('modal-dismiss');
			// lazy clear
			setTimeout(() => { this.processing = false; }, 1000);
		},
		async toggleStatus(ev, newStatus) {
			// ev.preventDefault();
			// ev.stopPropagation();
			// this.$emit('toggle-stream', this.stream);
			// TODO this is a legasy hack we should get rig of this in the future. All stream updates should go throug the storage. Not with direct changes!
			const oldStatus = this.streamStatus;
			newStatus = newStatus === undefined ? !oldStatus : newStatus;
			this.streamStatus = newStatus;
			// this.stream.enabled = newStatus;
			if (this.$route.name == 'LivestreamManageDashboard' || this.$route.name == 'ScheduledStreamManageDashboard') {
				this.stream.enabled = newStatus;
			}
			try {
				this.$emit('toggle-processing', true)
				this.hideLegacyModal();

			if (!this.transcoderView) {
				await StreamService.toggleStream(this.stream._id);
				await this.$store.dispatch('Streams/getStreams', true); // force refresh to get updated state
			} else {
				await TranscoderService.toggleTranscoder(this.stream._id);
				await this.$store.dispatch('Transcoders/getTranscoders', true); // force refresh
			}
				this.$emit('toggle-done', true)
				// this.streamStatus = newStatus;
				// this.stream.enabled = newStatus;

				track(newStatus ? EVENTS.STREAM_ENABLED : EVENTS.STREAM_DISABLED, {
					streamType: this.stream.type,
					destinationCount: this.stream.platforms?.length
				});
				this.$notify({ group: "success", text: `You ${newStatus ? 'enabled' : 'disabled'} ${
						this.stream.name} stream` });
			} catch (err) {
				console.error('toggleStatus error: ', err);
				this.streamStatus = oldStatus;
				this.stream.enabled = oldStatus;

				this.$notify({
					group: 'error',
					title: "Couldn't toggle stream status",
					text: err.message
				});

				if (err.message && err.message.indexOf('upgrade') > -1) {
					showModal('billing-prompt');
				}
				setTimeout(() => {
					this.$emit('toggle-processing', false)
				}, 2000);
			}

			setTimeout(() => {
				this.$emit('toggle-processing', false)
			}, 2000);
			this.statusProcessing = false;
		},
	},
	watch: {
		stream() {
			this.streamStatus = this.stream.enabled;
		}
	}
};
</script>

<style scoped>

</style>
